import { render, staticRenderFns } from "./GroupAdd.vue?vue&type=template&id=409e97da&"
import script from "./GroupAdd.vue?vue&type=script&lang=js&"
export * from "./GroupAdd.vue?vue&type=script&lang=js&"
import style0 from "./GroupAdd.vue?vue&type=style&index=0&id=409e97da&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports